import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}

/**
 * Overrides the console.log method to display a custom message
 * whenever the console is used. The message includes a bug report prompt,
 * the developer's email, and the current URL with a timestamp.
 */
function setupCustomConsoleMessage() {
  const DEVELOPER_EMAIL = 'ritik.raj@sarvm.ai';
  const COFFEE_LINK = 'https://www.buymeacoffee.com/ritikraj';

  const messages = [
    `%c🐞 Found a bug? 🐞\n\nI see you're testing my skills… challenge accepted! 😎\nSend me an email at %c${DEVELOPER_EMAIL}%c, and I'll fix it faster than you can say “game on!” 🚀`,
    `%c🐞 Oh no, a bug? 🐞\n\nDon't worry, I'll fix it.... \nSend me a note at %c${DEVELOPER_EMAIL}%c, and I'll make it right faster than you can say “thank you!” 🚀`,
    // `%c 🕵️‍♂️ Hmm, something's not right? 🕵️‍♂️\n\nDon't worry, I love a good mystery… especially when it involves you. \nSend me a clue at %c${DEVELOPER_EMAIL}%c, and I'll solve it faster than you can say “sleuth!” 🚀`,
    // `%c🐞 Found a bug? 🐞\n\nWell, aren't you sharp-eyed? 😉\nDrop me a line at %c${DEVELOPER_EMAIL}%c, and I'll make it disappear faster than your crush's text replies! 🚀`,
  ];

  const MAIN_STYLE = 'font-size: 16px; font-weight: bold; line-height: 1.5;';
  const EMAIL_STYLE = 'color: red; font-size: 14px; text-decoration: underline;';
  const RESET_STYLE = 'color: initial; font-size: initial; font-weight: initial;';

  // Randomly pick a message
  const randomIndex = Math.floor(Math.random() * messages.length);
  const randomMessage = messages[randomIndex];

  // Display the random message
  console.log(randomMessage, MAIN_STYLE, EMAIL_STYLE, RESET_STYLE);
}

// Set up the custom console message
setupCustomConsoleMessage();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

defineCustomElements(window)
